<template lang="pug" src="./sidebarMenu.pug"></template>

<script>
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import openMenu from '../../../events/openMenu'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'SidebarMenu',

  data () {
    return {
      isLoadingData: true,
      functionalitiesGroup: [],
      home: PATHS.HOME,
      loadingGif: require('../../../assets/loading-gif/loading.svg')
    }
  },

  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    client () {
      return this.$store.getters.client
    },
    popupConfirmResponse () {
      return this.$store.getters.popupConfirmResponse
    },
    isOpen () {
      return this.$store.getters.isOpen
    },
    currentPath () {
      return this.$store.getters.currentPath
    },
    isEmulatedLogin () {
      return this.$store.getters.isClientEmulatedLogin
    }
  },

  watch: {
    client () {
      if (this.client) {
        this.loadFuncionalities()
        this.loadAplications()
      }
    },
    isOpen () {
      for (const group of this.functionalitiesGroup) {
        group.selected = false
      }
    },
    currentPath () {
      this.setSelectedItemGroup()
    }
  },

  methods: {
    setSelectedItemGroup () {
      for (const grupo of this.functionalitiesGroup) {
        grupo.active = false
        for (const funcionalidade of grupo.funcionalidades) {
          funcionalidade.active = false
          if (funcionalidade.path === this.currentPath) {
            funcionalidade.active = true
            grupo.active = true
            break
          }
        }
      }
    },

    clearSelectedMenuItem () {
      trackAnalyticsEvent(this, 'redirect-para-dashboard', 'logo-click', 'redirect-para-dashboard')
    },

    groupClicked (grupo) {
      if (!this.isOpen) {
        return
      }

      let alreadyActivatedSomeGroup = false
      grupo.selected = !grupo.selected

      this.functionalitiesGroup = this.functionalitiesGroup.map(g => {
        if (!alreadyActivatedSomeGroup) {
          g.active = g.funcionalidades.some(f => f.path === this.currentPath)
          alreadyActivatedSomeGroup = g.active
        }

        if (g !== grupo) {
          g.selected = false
        }
        return g
      })

      trackAnalyticsEvent(this, 'menu-lateral', 'grupo-funcionalidade-click', grupo.key)
    },

    functClicked (funcionalidade, grupo) {
      grupo.funcionalidades.map(f => {
        f.active = false
      })
      funcionalidade.active = true
      trackAnalyticsEvent(this, 'menu-lateral', 'funcionalidade-click', funcionalidade.key)
      if (!this.popupConfirmResponse) {
        return
      }
      this.$store.dispatch('selectMenuItem', { funcionalidade, grupo })
    },

    loadFuncionalities () {
      let self = this
      this.$store.dispatch('getFuncionalities').then((response) => {
        this.functionalitiesGroup = response.data.funcList.map(grupo => {
          grupo.active = false
          grupo.text = this.$t(`menu.grupos.${grupo.key}`)

          if (!self.$store.getters.isClientEmulatedLogin) {
            if (grupo.key === 'registro') {
              grupo.funcionalidades = grupo.funcionalidades.filter(funcionalidade => {
                return funcionalidade.key !== 'categorias' && funcionalidade.key !== 'planosConciliacao' && funcionalidade.key !== 'atributos'
              })
            }
          }

          // remove calendário da lista de menus
          grupo.funcionalidades = grupo.funcionalidades.map(funcionalidade => {
            funcionalidade.active = false
            if (funcionalidade.key === 'resumoConciliacao' || funcionalidade.key === 'calendarioResumoConciliacao') {
              funcionalidade.text = this.$t('menu.funcionalidades.resumoConciliacao')
              funcionalidade.ordemListagem = 2
            } else {
              funcionalidade.text = this.$t(`menu.funcionalidades.${funcionalidade.key}`)
            }
            return funcionalidade
          })

          let seen = new Set()
          grupo.funcionalidades = grupo.funcionalidades.filter(obj => {
            if (seen.has(obj.text)) {
              return false
            }
            seen.add(obj.text)
            return true
          })
          grupo.funcionalidades.sort((a, b) => a.ordemListagem - b.ordemListagem)
          return grupo
        })

        this.setSelectedItemGroup()
        this.isLoadingData = false
        this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc)
      })
    },

    loadAplications () {
      let self = this
      this.$store.dispatch('getAplicacoes')
        .then((data) => {
          this.$store.dispatch('setAplicacoes', data)
        }).catch((error) => {
          self.$root.$refs.notification.error(error.message)
        })
    },

    openCloseSidebarMenu () {
      this.$store.dispatch('setMenuState', this.isOpen)

      if (this.isOpen) {
        trackAnalyticsEvent(this, 'menu-lateral', 'menu-toggle', 'expandido')
      } else {
        trackAnalyticsEvent(this, 'menu-lateral', 'menu-toggle', 'retraído')
      }

      openMenu.$emit('menuOpened')
    },

    setFullStory () {
      this.$FullStory.identify(String(this.$store.getters.userId))
      this.$FullStory.setUserVars({
        conc_idCliente: this.$store.getters.client,
        conc_idUsuario: this.$store.getters.userId,
        conc_idPerfilAcesso: this.$store.getters.accessProfileId,
        conc_nomePerfilAcesso: this.$store.getters.accessProfileName,
        conc_aplicacao: 'Banking'
      })
    }
  },

  created () {
    this.$store.dispatch('setMenuState', false)
    if (this.isLoggedIn && this.client) {
      this.loadFuncionalities()
      this.loadAplications()
      this.setFullStory()
    }
  }
}
</script>

<style lang="scss">
@mixin force-hardware-accelaration {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;

  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -ms-perspective: 1000;
  perspective: 1000;
}

@mixin handle-hover-on-list {
  ul > li {
    > a.group {
      > p.group-text {
        display: none;
      }

      &:hover + ul.group-options {
        display: block!important;
      }
    }

    ul.group-options {
      width: 267px;
      position: absolute;
      left: 70px;
      margin-top: -53px;
      display: none;
      border: 1px solid #21252d;
      border-radius: 5px;
      z-index: 253 !important;
      height: auto!important;

      &:hover {
        display: block!important;
      }

      span {
        border-top: 1px solid #10253E;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        background-color: #10253E;
        font-size: 13px;
        padding: 20px 18px;
        font-family: 'Inter', sans-serif !important;
        color: #37F3F5;
        font-weight: 600;
        letter-spacing: 0.1117em;
        width: 100%;
        display: block;
      }

      > li {
        background-color: #123258;
        padding-left: 0!important;

        &:last-child {
          border-bottom: 1px solid #123258;
          border-bottom-left-radius: 3px;
          border-bottom-right-radius: 3px;
        }
      }
    }
  }
}

#menu-lateral {
  position: relative;
}

body {
  &.sidebar-visible {
    .page-content-wrapper {
      padding: 80px 0 0 105px;
    }
  }

  .page-content-wrapper {
    transition: all 150ms cubic-bezier(.05, .74, .27, .99);
    @include force-hardware-accelaration;

     > .container-fluid.container-fixed-lg {
      width: auto!important;
    }
  }
}

// Abaixo de 991px de largura.
@media (max-width: 991px) {
  body {
    .page-content-wrapper {
      margin-right: 0!important;
    }

    .page-sidebar {
      transition: width 150ms cubic-bezier(.05, .74, .27, .99);
      margin-left: 0;
      display: block;
      z-index: 253 !important;

      .sidebar-menu > p.group-text {
        display: none;
      }

      .sidebar-bottom {
        display: none;
      }
    }
  }

  // Sidebar aberto abaixo de 991px.
  body.sidebar-visible {
    .page-content-wrapper {
      padding: 80px 0 0 70px!important;
    }

    .header {
      margin-left: 70px!important;
      width: calc(100% - 70px)!important;
    }

    .page-sidebar {
      width: 70px !important;

      .sidebar-header a {
        background: url(../../../assets/logos_equals/logo_equals_quadrado.png) no-repeat 50% 50%;
      }

      .sidebar-menu {
        @include handle-hover-on-list;
      }
    }
  }

  // Sidebar fechado abaixo de 991px.
  body.sidebar-invisible {
    .page-content-wrapper {
      padding: 80px 0 0 0px!important;
    }

    .header {
      margin-left: 0!important;
      width: 100%!important;
    }

    .page-sidebar {
      width: 0!important;
      > * {
        display: none;
      }
    }
  }
}

// Acima de 991px de largura.
@media (min-width: 992px) {
  body {
    .page-sidebar {
      margin-left: 210px;
    }
  }
  /**
    * Sidebar aberto acima de 991px.
    */
  body.sidebar-visible {
    .page-content-wrapper {
      margin-right: 50px!important;
      padding: 80px 0 0 300px;
    }

    .header {
      margin-left: 260px;
      width: calc(100% - 260px);
    }

    .page-sidebar {
      width: 260px;

      .sidebar-header a {
        background: url(../../../assets/logos_equals/logo_equals_branco.png) no-repeat 50% 50%;
      }

      .sidebar-menu {
        ul > li {
          &.selected {
            background-color: #132E4D;

            > a.group {
              > * {
                color: #37F3F5!important;
              }

              > p::after {
                content: "\f077";
              }
            }
          }

          ul.group-options {
            background-color: #10253E;
            width: inherit;
            overflow-y: hidden;
            transition-property: max-height;
            transition-duration: 150ms;
            -webkit-transition-delay: 0ms;
            -moz-transition-delay: 0ms;
            -o-transition-delay: 0ms;
            transition-delay: 0ms;
            @include force-hardware-accelaration;

            > span {
              display: none;
            }

            &.is-expanded {
              transition-timing-function: ease-in;
              max-height: 999px;
            }

            &.is-collapsed {
              transition-timing-function: ease-out;
              max-height: 0;
            }

            > li {
              background-color: #10253E!important;
            }
          }
        }
      }
    }
  }

  /**
    * Sidebar fechado acima de 991px.
    */
  body.sidebar-invisible {
    .page-content-wrapper {
      margin-right: 50px!important;
      padding: 80px 0 0 105px;
    }

    .header {
      margin-left: 70px;
      width: calc(100% - 70px);
    }

    .page-sidebar {
      width: 70px!important;

      .sidebar-header a {
        background: url(../../../assets/logos_equals/logo_equals_quadrado.png) no-repeat 50% 50%;
      }

      .sidebar-menu {
        @include handle-hover-on-list;
      }
    }
  }
}

/**
  * Estilo comum do sidebar, nesse caso, o sidebar aberto e fechado.
  */
.page-sidebar {
  transition: all 150ms cubic-bezier(.05, .74, .27, .99);
  z-index: 253 !important;
  @include force-hardware-accelaration;

  .sidebar-header {
    background: #142C4F;
    border: none;
    padding: 0px;
    height: 60px;
    width: 100%;

    a {
      transition: unset!important;
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .sidebar-menu {
    background-color: #1B3C65;

    ul {
      position: relative;
      height: 100%;
      margin-bottom: 0px;
      margin-right: 0px;
      max-height: 999px;
      list-style: none;
      display: block;
      width: 100%;

      > li.loading-functionalities {
        height: 85%;
        padding: 0!important;
        line-height: 0!important;
        text-align: center;

        &::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
          font-size: 0;
        }

        & > * {
          vertical-align: middle;
          width: 100%;
          max-width: 70px;
        }
      }

      > li:not(.loading-functionalities) {
        padding: 0px !important;
        width: 100%;
        line-height: 0px;
        min-height: 53px;
        position: relative;
        display: block;
        clear: right;

        &:hover:not(.active) {
          text-decoration: none;
          background-color: #132E4D;
          transition: color,background-color 100ms linear;
          @include force-hardware-accelaration;

          > a.group > * {
            color: #FFF;
          }
        }

        &.active {
          background-color: #132E4D;

          > a.group {
            border-color: #37F3F5;

            > * {
              color: #37F3F5!important;
            }
          }
        }

        > a.group {
          border-left: 5px solid transparent;
          line-height: 53px;
          display: inline-flex;
          padding-left: 15px;
          text-decoration: none;
          width: 100%;

          > .group-icon {
            width: 30px;
            text-align: center;

            > i {
              font-size: 18px;
            }
          }

          .group-icon, p {
            color: #8AA4AF;
            font-weight: 600;
            letter-spacing: 0.1em;
          }

          p.group-text {
            position: absolute;
            font-size: 13px;
            margin-left: 40px;
            line-height: 53px;
            transition: unset !important;

            &::after {
              content: "\f078";
              font-family: FontAwesome;
              font-style: normal;
              right: 15px;
              position: fixed;
            }
          }
        }

        ul.group-options > li {
          min-height: 36px;
          line-height: 22px;
          padding-left: 25px!important;

          &.active {
            font-weight: 600;

            > a {
              color: white!important;
            }
          }

          > a {
            letter-spacing: 0;
            text-decoration: none;
            width: 100%;
            font-family: 'Inter', serif !important;
            color: #8AA4AF;
            padding: 6px 18px 6px 35px;
            width: 100%;
            display: block;

            &:hover {
              color: white;
              font-weight: 600;
            }
          }
        }
      }
    }
  }

  .sidebar-bottom {
    background-color: #132C4A;
    vertical-align: middle;
    height: 40px;
    width: 100%;
    z-index: 253 !important;
    position: absolute;
    bottom: 0;
    color: #FFF;
    cursor: pointer;
    padding-top: 12px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?c0ceaef2